import { html } from "lit-element";
import {store} from "@stofloos/stores/store";
import { StofwareCrudSingle } from "@stofloos/core/base/sw-crud-single";
import "@stofloos/components/molecules/filters/filter-sortby";
import { ButtonOutlinedStyle } from "@stofloos/components/atoms/buttons/button-outlined";
import { localize } from "@stofloos/actions/localize";
import { TableStyle } from "./style";

import { LayoutFlex } from "@stofloos/globals/styles/layout-flex";

import find from "lodash-es/find";
import get from "lodash-es/get";

import "@stofloos/components/molecules/forms/sw-form";
import "@stofloos/components/atoms/fields/sw-date";
import {openDialog, closeDialog} from "@stofloos/actions/dialog";
import {formToJSON, getFormElements, validateForm} from "@stofloos/utils/sw-constants";
import assign from "lodash-es/assign";
import {updateObject} from "@stofloos/actions/crud";

const defaultInputForm = [
	{
		"elements": [
			{
				label: "Kolom naam",
				name: "name",
				type: "text"
			},
			{
				label: "Kolom label",
				name: "label",
				type: "text"
			},
			{
				label: "Kolom type",
				name: "type",
				type: "select",
				options: [
					{
						label: "Tekst",
						name: "text"
					},
					{
						label: "Nummeriek",
						name: "number"
					}
				]
			}
		]
	}
];

class TableDynamic extends StofwareCrudSingle {
	static get styles() {
		return [LayoutFlex, ButtonOutlinedStyle, TableStyle];
	}
	static get properties() {
		return {
			objects: Array,
			meta: Object,
			identifier: String
		};
	}

	constructor() {
		super();
	}

	render() {
		// language=HTML
		return html`
			<div class="table-container layout vertical flex">
				<div class="table-header table-row">
					${this.meta.model && this.meta.model.length > 0
						? this.meta.model.map(column => {
								return html`
									<div class="table-header-column">
										<filter-sortby requestId="${this.requestId}" .column="${column}"></filter-sortby>
									</div>
								`;
						  })
						: ""}
					
					<div class="table-header-add-column" @click="${()=> store.dispatch(openDialog('addTableColumn'))}"><sw-icon icon="plus"></sw-icon></div>
				</div>
				${this.objects && this.objects.length > 0
					? this.objects.map(object => {
							return html`
								<div class="table-content-row table-row">
									${this.meta.model && this.meta.model.length > 0
										? this.meta.model.map((column, index) => {
												return html`
													${index === 0
														? html`
																<a
																	style="font-weight: bold;"
																	href="/${this.endpoint}/details/${this.identifier ? get(object, this.identifier) : object.id}"
																	class="table-column"
																>
																	${column.type === "date"
																		? html`
																				<sw-date
																					date="${get(object, column.name)}"
																					format="${column.format}"
																				></sw-date>
																		  `
																		: html`
																				${column.type === "boolean"
																					? html`
																							${get(object, column.name)
																								? localize(column.name)
																								: "-"}
																					  `
																					: html`
																							${localize(
																								get(object, column.name)
																							)}
																					  `}
																		  `}
																</a>
														  `
														: html`
																<div class="table-column">
																	${column.type === "date"
																		? html`
																				<sw-date
																					date="${get(object, column.name)}"
																					format="${column.format}"
																				></sw-date>
																		  `
																		: html`
																				${column.type === "boolean"
																					? html`
																							${get(object, column.name)
																								? localize(column.name)
																								: "-"}
																					  `
																					: html`
																							${localize(
																								get(object, column.name)
																							)}
																					  `}
																		  `}
																</div>
														  `}
												`;
										  })
										: ""}
								</div>
							`;
					  })
					: ""}
			</div>
			
			
			<dialog-simple dialogId="addTableColumn">
				<sw-form .config="${defaultInputForm}"></sw-form>
				<div class="layout vertical center-center">
					<button-outlined lowecase strong @click="${this.addColumn}" label="${localize("main::create")}">
					</button-outlined>
				</div>
			</dialog-simple>
		`;
	}

	addColumn() {
		const form = this.shadowRoot.querySelector('sw-form');
		const formElements = getFormElements(form);
		if(!validateForm(formElements)){
			isValid = false;
			return;
		}
		const data = formToJSON(formElements);
		const config = store.getState().app.config;
		this.meta.model.push(data);
		find(config.config.endpoints,  { 'endpoint': this.endpoint } ).meta = this.meta;

		this.requestUpdate();

		store.dispatch(updateObject("appSettings", config)).then((response) => {
		});

		store.dispatch(closeDialog('addTableColumn'));
	}

	openObject(e, id) {
		const object = find(this.objects, ["id", id]);

		let event = new CustomEvent("sw-table:read-object", {
			detail: { object: object },
			bubbles: true,
			composed: true
		});

		this.dispatchEvent(event);
	}
}

window.customElements.define("table-dynamic", TableDynamic);
